export const theme = {
	borderRadius: '',
	gap: '',
	aspectRatio: {
		columns1: '',
		columns2: '',
		columns4: '',
	},
	mobile: {
		gap: '',
		aspectRatio: {
			columns1: '',
			columns2: '',
		},
	},
};
